export default __webpack_public_path__ + "static/media/banner_avator.1ef5fe95.webp";